import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { useT } from '@/context/LocaleContext';

/**
 * Auto-translate a piece of text based on current locale. Falls back to original on error.
 * Caches per (text, locale) in-memory to avoid double calls in the same session.
 */
const memoryCache = new Map();

export default function TranslatedText({ text, cacheKey, className, as: Tag = 'span' }) {
  const { locale } = useT();
  const [out, setOut] = useState(text);

  useEffect(() => {
    if (!text) { setOut(''); return; }
    if (locale === 'fr') { setOut(text); return; }
    const mkey = `${cacheKey || text.slice(0, 80)}::${locale}`;
    if (memoryCache.has(mkey)) { setOut(memoryCache.get(mkey)); return; }
    setOut(text); // show original while loading
    let alive = true;
    (async () => {
      try {
        const { data } = await api.post('/translate', { text, target: locale, key: cacheKey });
        if (alive && data?.text) {
          memoryCache.set(mkey, data.text);
          setOut(data.text);
        }
      } catch { /* fall back to original */ }
    })();
    return () => { alive = false; };
  }, [text, locale, cacheKey]);

  return <Tag className={className}>{out}</Tag>;
}
